import errorManager from '@/rollbar.js';

export const isPushStateSupported = () => !!history;
export const clearUtmSource = () => {
  let url = new URL(window.location.href);
  url.searchParams.delete('utm_source');
  if (isPushStateSupported()) {
    history.replaceState(history.state, document.title, url);
  }
};
const unitCleaner = () => {
  try {
    clearUtmSource();
  } catch (e) {
    errorManager(e);
  }
};

window.Utils.clearUtmSource = unitCleaner;
